import React from "react";
import PropTypes from "prop-types";
import "./Cells.style.scss";

const Cells = ({
  value_1,
  value_2,
  value_3,
  title,
  paddingLeft,
  pl_17,
  pr_18,
}) => {
  return (
    <div className="tree_table_cellbars">
      <div
        className={`${paddingLeft ? "pl_35" : ""} ${
          pl_17 ? "pl_17" : ""
        } cl_color1`}
        title={`${title} : ${+value_1.toFixed(2)}%`}
      >
        {+value_1.toFixed(2)}%
      </div>
      <div
        className={`cl_color2`}
        title={`${title} : ${+value_2.toFixed(2)}% (FI BM)`}
      >
        {+value_2.toFixed(2)}%
      </div>
      <div
        className={`${pr_18 ? "pr_18" : ""} cl_color3`}
        title={`${title} : ${+value_3.toFixed(2)}% (EQ BM)`}
      >
        {+value_3.toFixed(2)}%
      </div>
    </div>
  );
};

Cells.propTypes = {
  value_1: PropTypes.number.isRequired,
  value_2: PropTypes.number.isRequired,
  value_3: PropTypes.number.isRequired,
  title: PropTypes.string,
};
export default Cells;



// WEBPACK FOOTER //
// ./src/components/common/treeTableWithSlider/cells/Cells.jsx